/* eslint-disable @typescript-eslint/ban-types */
import { Action, Dispatch } from "redux";
import {
  CreateBandDetail,
  Environments,
  EthnicityType,
  GetBandDetail,
  UpdateBandDetail
} from "@emisgroup/cohort-builder-kit";
import { setNotification } from "../../../../utilities/HttpRequest/Script";
import { ProgressSpinnerSlice } from "../../../ProgressSpinner/Index";
import { OutputConfigSlice } from "../redux";
import { handleException } from "../../../../ErrorMessages/helper";
import { BANDINGSAVE } from "../Constant";
import { DefaultFromEntry, DefaultToEntry } from "./BandingAgeForm/MockData";
import { AgeRangeType, AgeTypes } from "./BandingAgeForm/Types";
import { Ethnicity } from "./BandingEthnicityForm/Data";
import { BandingDetailsProps } from "./Helper";

/**
 * Function to fetch the banding details
 * @param dispatch Function to dispatch
 * @param translate Function to translate
 * @param selectedConfigId Config ID
 */
export const FetchBandingDetails = async (
  dispatch: Dispatch<Action>,
  translate: Function,
  selectedConfigId: string,
  env: Environments,
  accessToken: string
): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.BandingDetails")));
    const res = await GetBandDetail(selectedConfigId, env, accessToken);
    if (res && res["data"]) {
      const { ageBand, genderBand, ethnicityBand } = res["data"]["payload"] || {};
      const bandings = {
        ageBand,
        genderBand,
        ethnicityBand
      };
      dispatch(OutputConfigSlice.actions.setBandingDetails(bandings));
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    }
  } catch (ex) {
    handleException(ex, dispatch, "GetBandingErrMsg");
  }
};

/**
 * To reset the selected banding details when closing the dialog
 * @param dispatch Function to dispatch the action
 */
export const ResetBandingTabEntries = (dispatch: Dispatch<Action>): void => {
  dispatch(OutputConfigSlice.actions.setSelectedBandingDetails({} as BandingDetailsProps));
  dispatch(OutputConfigSlice.actions.updateSelectedGenders({
    value: "",
    checked: false,
    isReset: true
  }));
  dispatch(OutputConfigSlice.actions.setSelectedAgeRangeFrom({ value: DefaultFromEntry.value }));
  dispatch(OutputConfigSlice.actions.setSelectedAgeRangeTo({ value: DefaultToEntry.value }));
  dispatch(OutputConfigSlice.actions.setEntryData(Ethnicity.entry));
  dispatch(OutputConfigSlice.actions.setSelectedFromType(AgeTypes.DATE));
  dispatch(OutputConfigSlice.actions.setSelectedToType(AgeTypes.DATE));
  dispatch(OutputConfigSlice.actions.setSelectedAgeValueFrom({} as AgeRangeType));
  dispatch(OutputConfigSlice.actions.setSelectedAgeValueTo({} as AgeRangeType));
};


/**
 * Function to save the band details
 * @param dispatch Function to dispatch
 * @param translate Function to translate
 * @param bandId Banding ID
 * @param bandMode Banding mode
 * @param configId Output config ID
 * @param bandType Banding type
 * @param bandName Banding name
 * @param definition Clint
 */
export const saveBandDetails = async (
  dispatch: Dispatch<Action>,
  translate: Function,
  configId: string,
  bandType: string,
  bandName: string,
  definition: string,
  ethnicFilter: EthnicityType,
  bandGuid: string,
  env: Environments,
  accessToken: string
): Promise<void> => {
  const payload = {
    bandType: bandType,
    name: bandName,
    definition: definition,
    ethnicityCategory: ethnicFilter
  };
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.SaveBanding")));
    let response;
    if (bandGuid) {
      response = await UpdateBandDetail(
        configId, payload, bandGuid, env, accessToken
      );
    } else {
      response = await CreateBandDetail(
        payload, configId, env, accessToken
      );
    }
    if (response) {
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
      ResetBandingTabEntries(dispatch);
      FetchBandingDetails(dispatch, translate, configId, env, accessToken);
      setNotification(dispatch, BANDINGSAVE, translate("Notification.SaveBanding"), "success");
    }
  } catch (ex) {
    handleException(ex, dispatch, "SaveBandingErrMsg");
  }
};
